const videoSource13 = [
  {
    id: "video16",
    src: require("./2_4.mp4"),
  },
  {
    id: "video17",
    src: require("./2_5.mp4"),
  },
  {
    id: "video18",
    src: require("./2_6.mp4"),
  },
];

export default videoSource13;
